import { ChevronRight } from "lucide-react";
import { Fragment, type FC, type ReactNode } from "react";

type Crumb = { label: string; onClick?: () => void };

type Props = {
  /** Where this page sits ("Requests", "Intake Templates"); the title is last. */
  crumbs: Crumb[];
  title: ReactNode;
  /** Status badge and save state beside the title. */
  meta?: ReactNode;
  actions?: ReactNode;
};

/**
 * The page's top bar: crumbs into the title, its status, and actions on the
 * right. Shared by the Requests pages and the Firm Knowledge template editor.
 */
export const PageBar: FC<Props> = ({ crumbs, title, meta, actions }) => (
  <header className="flex h-10 shrink-0 items-center gap-2 border-b border-line-1 bg-surface pr-2 pl-4">
    <nav
      aria-label="Breadcrumb"
      className="flex min-w-0 flex-1 items-center gap-1.5 text-base"
    >
      {crumbs.map((c) => (
        <Fragment key={c.label}>
          {c.onClick ? (
            <button
              type="button"
              onClick={c.onClick}
              className="shrink-0 font-medium text-fg-3 hover:text-fg"
            >
              {c.label}
            </button>
          ) : (
            <span className="shrink-0 font-medium text-fg-3">{c.label}</span>
          )}
          <ChevronRight className="size-3.5 shrink-0 text-fg-4" />
        </Fragment>
      ))}
      <span className="min-w-0 truncate font-medium text-fg">{title}</span>
      {meta ? (
        <span className="flex shrink-0 items-center gap-2">{meta}</span>
      ) : null}
    </nav>
    {actions ? (
      <div className="flex shrink-0 items-center gap-1.5">{actions}</div>
    ) : null}
  </header>
);
